import $ from 'jQuery';
import Vue from 'vue';
import fields from '@/lib/components/Fields';
import InlineField from '@/lib/components/Fields/InlineField';

export default function(root){
  (root ? root.find('.vue-field') : $('.vue-field')).each(function(){
    $(this).removeClass('.vue-field')

    new Vue({
      el: this,
      components: {...fields, InlineField}
    });
  });
}
